import React from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import ToBeActionedTab from './ToBeActionedTab';
import AcceptedProposalsTab from './AcceptedProposalsTab';
import HistoryTab from './HistoryTab';
import './RMCProposalManagement.css';
import PageHeader from '../PageHeader';

const RMCProposalManagement: React.FC = () => {
    return (
        <div className="content">
            <div className="content-header">
        <div className="container d-flex align-items-center">
          <h6 className="_600 mb-2 page-heading">Proposal Management</h6>
        </div>
      </div>
            {/* <PageHeader title="Proposal Management" /> */}

            <div className="content-body">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="card border-0">
                                <div className="card-body p-3">
                                    <div className="proposal-tabs-container">
                                        <TabView className="rmc-proposal-tabs">
                                            <TabPanel header="To Be Actioned" leftIcon="pi pi-clock">
                                                <ToBeActionedTab proposalStatus="Proposed" isActive={true} isReadOnly={false} />
                                            </TabPanel>
                                            <TabPanel header="Active" leftIcon="pi pi-check-circle">
                                                <ToBeActionedTab proposalStatus="Approved" isActive={true} isReadOnly={true} />
                                            </TabPanel>
                                            <TabPanel header="Inactive" leftIcon="pi pi-times-circle">
                                                <ToBeActionedTab proposalStatus="Approved" isActive={false} isReadOnly={true} />
                                            </TabPanel>
                                            {/* <TabPanel header="Accepted Proposals" leftIcon="pi pi-check">
                                                <AcceptedProposalsTab />
                                            </TabPanel>
                                            <TabPanel header="History" leftIcon="pi pi-history">
                                                <HistoryTab />
                                            </TabPanel> */}
                                        </TabView>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RMCProposalManagement;
